import { IApplicationState } from '../../types/redux';

export const selectBiggestBuildersPromos = (state: IApplicationState) => {
  return state.promosPage.biggestBuildersPromos;
};
